import React from 'react';
import { Sprout, Scissors, Wind, ArrowRight } from 'lucide-react';
export function Services() {
  return <section id="services" className="py-24 bg-gray-50" data-id="element-157">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-159">
          <h2 className="text-emerald-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-160">
            Our Services
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-161">
            Expert Lawn Care Services
          </h3>
          <p className="text-lg text-gray-600" data-id="element-162">
            We specialize in core lawn care services: professional mowing,
            seasonal aeration, and fertilization programs to keep your lawn
            healthy and beautiful.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-163">
          {/* Service 1: Lawn Mowing */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md hover:border-emerald-100 transition-all group" data-id="element-164">
            <div className="h-14 w-14 bg-emerald-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-emerald-600 transition-colors" data-id="element-165">
              <Scissors className="h-7 w-7 text-emerald-600 group-hover:text-white transition-colors" data-id="element-166" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-167">
              Lawn Mowing
            </h4>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-168">
              Professional mowing services with precision edging along driveways
              and sidewalks, plus thorough cleanup of all clippings for a
              pristine finish every time.
            </p>
            <a href="#contact" className="inline-flex items-center text-emerald-600 font-medium hover:text-emerald-700 group/link" data-id="element-169">
              Request Service{' '}
              <ArrowRight className="ml-1 h-4 w-4 group-hover/link:translate-x-1 transition-transform" data-id="element-170" />
            </a>
          </div>

          {/* Service 2: Core Aeration */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md hover:border-emerald-100 transition-all group" data-id="element-171">
            <div className="h-14 w-14 bg-emerald-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-emerald-600 transition-colors" data-id="element-172">
              <Wind className="h-7 w-7 text-emerald-600 group-hover:text-white transition-colors" data-id="element-173" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-174">
              Core Aeration
            </h4>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-175">
              Twice-yearly aeration service to relieve soil compaction and allow
              water, air, and nutrients to reach the root zone for a thicker,
              healthier lawn.
            </p>
            <a href="#contact" className="inline-flex items-center text-emerald-600 font-medium hover:text-emerald-700 group/link" data-id="element-176">
              Request Service{' '}
              <ArrowRight className="ml-1 h-4 w-4 group-hover/link:translate-x-1 transition-transform" data-id="element-177" />
            </a>
          </div>

          {/* Service 3: Fertilization */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md hover:border-emerald-100 transition-all group" data-id="element-178">
            <div className="h-14 w-14 bg-emerald-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-emerald-600 transition-colors" data-id="element-179">
              <Sprout className="h-7 w-7 text-emerald-600 group-hover:text-white transition-colors" data-id="element-180" />
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-181">
              Fertilization
            </h4>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-182">
              Bi-annual fertilization program designed for your specific soil
              type and grass species to promote thick, vibrant, healthy growth
              throughout the season.
            </p>
            <a href="#contact" className="inline-flex items-center text-emerald-600 font-medium hover:text-emerald-700 group/link" data-id="element-183">
              Request Service{' '}
              <ArrowRight className="ml-1 h-4 w-4 group-hover/link:translate-x-1 transition-transform" data-id="element-184" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}